module.exports = __webpack_public_path__ + "img/table.8cbdc959.svg";